/* @jsx jsx */
import { jsx } from '@theme-ui/core';
import * as React from 'react';
import { BoxProps } from './Box';
import { Icon } from './Icon2';
import { Inline } from './Inline';
import { Stack } from './Stack';

type Props = {
  label: string;
  value: string;
  count?: string | number | null;
  disabled?: boolean;
};

type FilterButtonProps = BoxProps & Props;

export const PrimaryFilterButton = React.forwardRef<HTMLDivElement, FilterButtonProps>(
  function PrimaryFilterButton(
    { label, value, count, disabled = false, ...props }: FilterButtonProps,
    ref
  ) {
    return (
      <Inline
        variant="buttons.primaryFilter"
        gap={1}
        align="space-between"
        alignY="center"
        {...props}
        ref={ref}
        data-disabled={disabled}
        onPointerDown={(e) => {
          if (!disabled && props?.onPointerDown) {
            props?.onPointerDown(e);
          }
        }}
        tabIndex={disabled ? -1 : props.tabIndex}
      >
        <Stack>
          <label>{label}</label>
          <Inline gap={1} sx={{ flex: 1 }}>
            <span
              sx={{
                fontWeight: 400,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {value}
            </span>
            {count != null ? <span>({count})</span> : null}
          </Inline>
        </Stack>
        <Icon aria-hidden="true" icon="keyboard_arrow_down" size={20} />
      </Inline>
    );
  }
);
